import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watchEffect } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import dayjs from "dayjs";

import {
  listCommentByPageUsingPost,
  updateCommentUsingPost,
} from "@/request/api/commentController";
import { deleteCommentUsingPost } from "@/request/api/commentController";
//初始值

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminCommentPage',
  setup(__props) {

const initParams = {
  current: 1,
  pageSize: 10,
  sortOrder: "ascend",
  sortField: "createTime",
};
//搜索参数
const formParams = ref<API.UserQueryRequest>({
  ...initParams,
});
//传递参数
const searchParams = ref<API.UserQueryRequest>({});
//数据
const dataList = ref<API.User[]>([]);
//总值
const total = ref<number>(0);
const loading = ref(false);
/**
 * 加载数据
 */
const loadData = async () => {
  loading.value = true;
  const response = await listCommentByPageUsingPost(searchParams.value);
  if (response.data.code === 0) {
    dataList.value = response.data.data?.records || [];
    total.value = response.data.data?.total || 0;
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
  loading.value = false;
};
/**
 * 搜索
 */
const search = () => {
  searchParams.value = { ...initParams, ...formParams.value };
};
/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});

/**
 * 当分页变化时，改变搜索条件，触发数据加载
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/**
 * 修改
 */
//旧的数据
const oldData = ref<API.Comment>({});
const updateVisible = ref(false);
const update = async (item: API.Comment) => {
  updateVisible.value = true;
  oldData.value = { ...item };
};
const updateSubmit = async () => {
  updateVisible.value = true;
  const response = await updateCommentUsingPost({
    id: oldData.value.id,
    content: oldData.value.content,
  });
  if (response.data.code === 0) {
    message.success("修改成功");
    updateVisible.value = false;
    loadData();
  } else {
    message.error("修改失败，" + response.data.message);
  }
};

/**
 * 删除
 */
const doDelete = async (id: number) => {
  if (!confirm("确定要删除吗？")) {
    return;
  }
  const res = await deleteCommentUsingPost({ id });
  if (res.data.code === 0) {
    loadData();
  } else {
    message.error("删除失败，" + res.data.message);
  }
};

const columns = [
  {
    title: "ID",
    dataIndex: "id",
  },
  {
    title: "业务ID",
    dataIndex: "bizId",
  },
  {
    title: "业务类型",
    dataIndex: "bizType",
  },
  {
    title: "父ID",
    dataIndex: "pid",
  },
  {
    title: "内容",
    dataIndex: "content",
  },
  {
    title: "用户ID",
    dataIndex: "userId",
  },
  {
    title: "对谁评论",
    dataIndex: "toUserId",
  },
  {
    title: "点赞数",
    dataIndex: "thumbNum",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    slotName: "createTime",
  },
  {
    title: "更新时间",
    dataIndex: "updateTime",
    slotName: "updateTime",
  },
  {
    title: "操作",
    slotName: "optional",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      layout: "inline",
      style: {"margin":"0 0 10px auto"},
      "label-align": "left",
      "auto-label-width": "",
      onSubmit: search
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "id",
          label: "ID："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formParams.value.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formParams.value.id) = $event)),
              placeholder: "请输入ID...",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "id",
          label: "业务ID："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formParams.value.bizId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formParams.value.bizId) = $event)),
              placeholder: "请输入业务ID...",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "id",
          label: "业务类型："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              "allow-clear": "",
              modelValue: formParams.value.bizType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formParams.value.bizType) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_option, { value: "Post" }, {
                  default: _withCtx(() => [
                    _createTextVNode("帖子")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, { value: "InterviewQuestion" }, {
                  default: _withCtx(() => [
                    _createTextVNode("面试题")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, { value: "App" }, {
                  default: _withCtx(() => [
                    _createTextVNode("应用")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "userId",
          label: "用户ID："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formParams.value.userId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formParams.value.userId) = $event)),
              placeholder: "请输入...",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "内容：" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formParams.value.content,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formParams.value.content) = $event)),
              placeholder: "请输入...",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit",
              style: {"width":"120px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("搜索 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_space, { size: "large" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { label: "排序：" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_group, {
              modelValue: formParams.value.sortOrder,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formParams.value.sortOrder) = $event)),
              type: "button"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio, { value: "ascend" }, {
                  default: _withCtx(() => [
                    _createTextVNode("正序")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio, { value: "descend" }, {
                  default: _withCtx(() => [
                    _createTextVNode("倒序")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "排序字段：" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_group, {
              modelValue: formParams.value.sortField,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formParams.value.sortField) = $event)),
              type: "button"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio, { value: "createTime" }, {
                  default: _withCtx(() => [
                    _createTextVNode("创建时间")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio, { value: "updateTime" }, {
                  default: _withCtx(() => [
                    _createTextVNode("更新时间")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createVNode(_component_a_modal, {
        visible: updateVisible.value,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((updateVisible).value = $event)),
        draggable: "",
        width: "600px",
        footer: false
      }, {
        title: _withCtx(() => [
          _createTextVNode("修改评论")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_a_form, { model: oldData.value }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_typography_text, null, {
                          default: _withCtx(() => [
                            _createTextVNode("内容")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_input, {
                          modelValue: oldData.value.content,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((oldData.value.content) = $event)),
                          placeholder: "请输入内容...",
                          "allow-clear": "",
                          style: {"width":"300px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_popconfirm, {
                      content: "确定要修改吗",
                      onOk: updateSubmit,
                      position: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, { type: "primary" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 修改")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createVNode(_component_a_table, {
      columns: columns,
      data: dataList.value,
      pagination: {
      showTotal: true,
      pageSize: searchParams.value.pageSize,
      current: searchParams.value.current,
      total: total.value,
    },
      stripe: true,
      bordered: { cell: true },
      loading: loading.value,
      onPageChange: onPageChange
    }, {
      createTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(dayjs)(record.createTime).format("YYYY-MM-DD")), 1)
      ]),
      updateTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(dayjs)(record.updateTime).format("YYYY-MM-DD")), 1)
      ]),
      optional: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "outline",
              onClick: ($event: any) => (update(record))
            }, {
              default: _withCtx(() => [
                _createTextVNode("修改")
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "outline",
              status: "danger",
              onClick: ($event: any) => (doDelete(record.id))
            }, {
              default: _withCtx(() => [
                _createTextVNode("删除 ")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination", "loading"])
  ], 64))
}
}

})